<template>
  <router-view />
</template>

<script>
import "select2/dist/css/select2.min.css"
import "@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css"

export default {
  name: 'App',
}
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;600;700&display=swap");
#app {
  font-family: 'Noto Sans JP', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2d3748;
}
</style>
